export default __webpack_public_path__ + "static/media/bild.e020d080.png";